import { ExternalLink, LoaderCircle } from "lucide-react";
import { Button } from "../../components/ui/button";
import { usePortalSession } from "../../hooks/usePortalSession";
import { cn } from "@/lib/utils";

export default function ManageBillingButton({
  text = "Manage plan",
  className,
  ...props
}) {
  const { mutate, data, isSuccess, isLoading } = usePortalSession();

  if (isSuccess) {
    window.location.href = data;
  }
  return (
    <Button
      variant="secondary"
      onClick={mutate}
      className={cn("gap-1", className)}
      {...props}
    >
      {text}
      {isLoading ? (
        <LoaderCircle className="h-4 w-4 animate-spin" />
      ) : (
        <ExternalLink />
      )}
    </Button>
  );
}
